var _defs, _rect, _text, _text2, _text3, _line, _line2, _line3, _text4, _line4, _line5, _line6, _rect2, _text5, _text6, _text7, _text8, _text9, _rect3, _text10, _text11, _text12, _text13, _text14, _rect4, _text15, _text16, _text17, _text18, _text19, _text20, _rect5, _text21, _text22, _text23, _text24, _text25, _text26, _rect6, _text27, _text28, _text29, _text30, _text31, _rect7, _text32, _text33, _text34, _text35, _line7, _line8, _line9, _line10, _line11, _line12, _text36, _text37, _text38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase6Fig4GateOrderCheapChecksFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 620",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1 L 8 5 L 0 9 Z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1240,
    height: 620,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The required gate, cheap copy checks first")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Stages in execution order, with the check counts each one carries at ship.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 160,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "CHEAP FIRST, FAILS IN SECONDS")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 176,
    x2: 350,
    y2: 176,
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 176,
    x2: 48,
    y2: 184,
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 176,
    x2: 350,
    y2: 184,
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 160,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "HEAVY SUITES, RUN ONLY AFTER THE CHEAP CHECKS PASS")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 372,
    y1: 176,
    x2: 1001,
    y2: 176,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 372,
    y1: 176,
    x2: 372,
    y2: 184,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1001,
    y1: 176,
    x2: 1001,
    y2: 184,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 235,
    width: 140,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 262,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "STAGE 1")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 286,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Voice and")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 303,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "copy lints")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 326,
    fontSize: 11.5,
    fill: "#4A5F56",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "voice_lint")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 346,
    fontSize: 11.5,
    fontWeight: 500,
    fill: "#16A34A"
  }, "fails in seconds")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 235,
    width: 140,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 262,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "STAGE 2")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 286,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Token lint")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 310,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "design tokens,")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 326,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "still cheap")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 346,
    fontSize: 11.5,
    fontWeight: 500,
    fill: "#16A34A"
  }, "fails in seconds")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 200,
    width: 195,
    height: 200,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 232,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "STAGE 3")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 258,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Machine judge")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 276,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "suite")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 330,
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "2,033")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 354,
    fontSize: 12,
    fill: "#6B7F74"
  }, "checks at ship")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 374,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "runs for minutes")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 200,
    width: 195,
    height: 200,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 232,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "STAGE 4")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 258,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "External judge")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 276,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "checks")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 330,
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "44")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 354,
    fontSize: 12,
    fill: "#6B7F74"
  }, "checks at ship")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 374,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "the slowest calls")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 200,
    width: 195,
    height: 200,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 232,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "STAGE 5")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 258,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Platform tests")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 330,
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "2,104")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 354,
    fontSize: 12,
    fill: "#6B7F74"
  }, "tests at ship")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 374,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "runs for minutes")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1023,
    y: 225,
    width: 169,
    height: 150,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 1039,
    y: 257,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "AT SHIP")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 1039,
    y: 305,
    fontSize: 32,
    fontWeight: 700,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "4,181")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 1039,
    y: 328,
    fontSize: 12,
    fill: "#4A5F56"
  }, "total checks")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 1039,
    y: 350,
    fontSize: 11,
    fill: "#6B7F74",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "2,033 + 44 + 2,104")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 191,
    y1: 300,
    x2: 205,
    y2: 300,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 353,
    y1: 300,
    x2: 367,
    y2: 300,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 570,
    y1: 300,
    x2: 584,
    y2: 300,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 787,
    y1: 300,
    x2: 801,
    y2: 300,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1004,
    y1: 300,
    x2: 1018,
    y2: 300,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 366,
    x2: 118,
    y2: 432,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 454,
    fontSize: 15,
    fontWeight: 700,
    fill: "#DC2626",
    textAnchor: "middle"
  }, "&#x2715;")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 453,
    fontSize: 13,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "A copy violation, one em dash in catalog copy, fails at stage 1 in seconds. The heavy suites never start for that push.")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 556,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "Cheap checks first means most failures cost seconds, and the 4,181-check gate spends its expensive minutes only on copy that already reads clean.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase6Fig4GateOrderCheapChecksFirst);
export default __webpack_public_path__ + "static/media/case6-fig4-gate-order-cheap-checks-first.2a056414137dc971defdbb5c0aa3d142.svg";
export { ForwardRef as ReactComponent };